import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "../../../helpers/axios";
import {Button} from "react-bootstrap";
import {SettingsEntry} from "../core/_models";
import {useAuth} from "../../auth";
import {LoadingIndicator} from "../../common/components/LoadingIndicator";
import {RequestError} from "../../common/components/RequestError";
import { Http } from "../../../helpers/http";

export function SelectDealer() {
    const {refreshUser, setSelectedDealer} = useAuth()
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [data, setData] = useState<null | SettingsEntry[]>(null);

    const navigate = useNavigate()

    const loadData = async () => {
        setError(false);
        setLoading(true);
        try {
            const {data} = await Http.get<SettingsEntry[]>('get_dealer_list');
            setData(data)
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const selectDealer = async (dealer: { id: number }) => {
        setLoading(true);
        try {
            await setSelectedDealer(dealer.id)
            await refreshUser()
            navigate('/')
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadData();
    }, [])

    return (
        <>
            {loading && <div className="text-center"><LoadingIndicator/></div>}
            {!loading && error && <RequestError onRefresh={loadData}/>}
            {!loading && data && <div className="d-grid gap-2">
                <h3 className="pb-5 text-center">Select Dealer</h3>
                {data.map(dealer => <Button
                    key={dealer.id}
                    variant="primary"
                    size="lg"
                    onClick={() => selectDealer(dealer)}
                >
                    {dealer.name} &rarr;
                </Button>)}
            </div>}
        </>
    )
}